import React from 'react'
import PropTypes from 'prop-types'
import { Spinner } from 'reactstrap'

const LoadingSpinner = ({ message = 'Carregando...', size, color = 'primary' }) => (
  <div className="text-center my-5" role="status" aria-live="polite">
    <Spinner color={color} size={size}>
      <span className="visually-hidden">{message || 'Carregando...'}</span>
    </Spinner>
    {message && <p className="mt-2 text-muted">{message}</p>}
  </div>
)

LoadingSpinner.propTypes = {
  message: PropTypes.string,
  size: PropTypes.oneOf(['sm']),
  color: PropTypes.string
}

export default LoadingSpinner
